import { cn } from "#app/utils/misc"

export default function HandmadeQualityArts({
	className,
}: {
	className?: string
}) {
	return (
		<picture>
			<source
				srcSet="/logos/handmade-quality-arts-400.webp 400w, /logos/handmade-quality-arts-600.webp 600w, /logos/handmade-quality-arts-800.webp 800w"
				sizes="(max-width: 640px) 80vw, (max-width: 768px) 280px, (max-width: 1024px) 320px, (max-width: 1280px) 400px, 500px"
				type="image/webp"
			/>
			<img
				src="/logos/handmade-quality-arts-600.png"
				srcSet="/logos/handmade-quality-arts-400.png 400w, /logos/handmade-quality-arts-600.png 600w, /logos/handmade-quality-arts-800.png 800w"
				sizes="(max-width: 640px) 80vw, (max-width: 768px) 280px, (max-width: 1024px) 320px, (max-width: 1280px) 400px, 500px"
				alt="Handmade Quality Arts"
				className={cn("h-auto w-full max-w-full", className)}
				width={481}
				height={450}
			/>
		</picture>
	)
}
